<template>
    <header>
        <div class="navbar-box">
            <!-- 右上角功能区域 -->
            <div class="version-box">
                <div style="display:flex; align-items:center">
                    <!-- 服务热线 -->
                    <div class="service-hotline">
                        全国服务热线：<span style="font-weight: bold;">400-829-6178</span>
                    </div>
                    <span style="margin: 0 20px; color: #fff;">|</span>
                    <!-- 入驻按钮 -->
                    <div v-if="isIndex" class="enter-buttons">
                        <router-link to="/merchants" exact class="enter-btn">供应商入驻</router-link>
                        <router-link to="/school" exact class="enter-btn">单位入驻</router-link>
                    </div>
                    <span v-if="isIndex" style="margin: 0 20px; color: #fff;">|</span>
                    <!-- 配送网链接 -->
                    <div class="delivery-link displayFlex disabledCopy cursor" @click="onDeliveryClick">
                        <img class="delivery-img" src="@/assets/image/index/kuaidi.png" alt="配送">
                        <div class="text">配送网</div>
                    </div>
                    <div class="shuxian"></div>
                    <!-- 举报 -->
                    <div class="tip_off displayFlex disabledCopy cursor" @click="onClickTips">
                        <img class="tip_img" :src="tip_img" alt="举报">
                        <div class="text">举报</div>
                    </div>
                </div>
            </div>
            <!-- Logo区域 -->
            <div class="logo-box">
                <div>
                    <div style="display: flex;align-items: center;gap: 10px;">
                        <img class="logo cursor" style="object-fit: contain;height: 100px;" 
                            src="https://liancan-oss.mmdiandi.com/FutureCanteen/liancanlogo.png" 
                            @click="onIndexClick" alt="LOGO" />
                        <img style="object-fit: contain;height: 100px;" 
                            src="https://liancan-oss.mmdiandi.com/FutureCanteen/liancanlogotxt.png" />
                    </div>
                    <!-- 左侧文字图片区域 -->
                    <div style="margin-top: 30px;padding-left:8px">
                        <img src="https://liancan-oss.mmdiandi.com/FutureCanteen/left-txt.png"/>
                    </div>
                </div>
                <div>
                    <div style="padding-top: 80px;">
                        <img src="https://liancan-oss.mmdiandi.com/FutureCanteen/right-txt.png"/>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import qr_code from '@/assets/image/index/qr_code.png'
import tip_img from '@/assets/image/index/icon_jubao.png'
export default {
    name: '',
    props: {
        logoUrl: { // title
            type: String,
            default: ''
        },
    },
    data() {
        return {
            qr_code,
            tip_img,
            isIndex: false, // 是否首页
            currentCity: '', // 当前城市
            logoUrlEnd: require('@/assets/image/index/logo20201219.png'), // 默认Logo
            // value: ["440000", "440900", "440904"], // 默认值
            cityDataArr: ['440000', '440900', '440904'], // 省市区级联列表
            provinceId: "", // 省id
            cityId: "", // 市id
            areaId: "", // 区id
            addressVal: [], // 选中的地址code集
            areaName: '广东省/茂名市/电白区', // 选中的地址名称
            // singleVal: '440904', // 选中项
            singleValList: [
                {
                    value: '440902',
                    label: '广东省 茂名市 茂南区',
                    // disabled: true
                },
                {
                    value: '440904',
                    label: '广东省 茂名市 电白区'
                },
                {
                    value: '440981',
                    label: '广东省 茂名市 高州市',
                    // disabled: true
                },
                {
                    value: '440982',
                    label: '广东省 茂名市 化州市',
                    // disabled: true
                },
                {
                    value: '440983',
                    label: '广东省 茂名市 信宜市',
                    // disabled: true
                },
            ]
        }
    },
    components: {},
    created() {
        this.getNodes();
        // 获取当前位置（如果使用百度地图API）
        if (typeof BMap !== 'undefined') {
            let ts = this
            new BMap.LocalCity().get(res => {
                ts.currentCity = res.name || '未知'
            })
        } else {
            this.currentCity = '未知'
        }
    },
    watch: {
        $route: function (newVal, oldVal) {
            let { name, path } = newVal
            if (name == 'Merchants' || name == 'School' || path == '/merchants' || path == '/school') {
                this.isIndex = true
            } else {
                this.isIndex = false
            }
        }
    },
    methods: {
        // 单项下拉选择
        // singleChange(value) {
        //     console.log('单项下拉选择', value, typeof value, value != '440904' ? '1':'1111');
        //     if (value != '440904') {
        //         return false
        //     }
        //     this.singleVal = value
        // },
        // 点击logo、网站名称跳回首页
        onIndexClick() {
            this.$router.push("/");
        },
        // 点击举报
        onClickTips() {
            // this.$message({
            //     message: '模块暂未开放',
            //     type: "warning",
            //     center: true
            // });
            this.$router.push({ path: "/complaint", query: { index: 10 } });
        },
        // 级联位置/单位选择
        handleChange(val) {
            this.getNodes(val);
            this.provinceId = val[0];
            this.cityId = val[1];
            this.areaId = val[2];
            this.getAreaName(val)
            console.log("级联位置/单位选择1", val);
        },
        // 筛选名称
        getAreaName(val) {
            let str = ''
            this.cityDataArr.forEach((itm, idx) => {
                if (itm.id == val[0]) {
                    str = itm.regionName + '/'
                    itm.cities.forEach((itc, idc) => {
                        if (itc.id == val[1]) {
                            str += itc.regionName + '/'
                            itc.cities.forEach((ita, ida) => {
                                if (ita.id == val[2]) {
                                    str += ita.regionName
                                }
                            })
                        }
                    })
                }
            })
            this.areaName = str
            console.log('this.areaName', this.areaName)
        },
        // 获取省市区数据
        getNodes(val) {
            let idArea;
            let sizeArea;
            if (!val) {
                idArea = null;
                sizeArea = 0;
                this.$get(this.$api.getProvince).then(res => {
                    let Items = res.data;
                    this.cityDataArr = Items.map((value, i) => {
                        return {
                            id: value.id,
                            regionName: value.regionName,
                            cities: []
                        };
                    });
                });
            } else if (val.length === 1) {
                idArea = val[0];
                sizeArea = val.length;
                this.cityDataArr.map((value, i) => {
                    if (value.id === val[0]) {
                        this.$get(this.$api.getCity + val[0]).then(res => {
                            let Items = res.data;
                            value.cities = Items.map((item, i) => {
                                return {
                                    id: item.id,
                                    regionName: item.regionName,
                                    cities: []
                                };
                            });
                        });
                    }
                });
            } else if (val.length === 2) {
                idArea = val[1];
                sizeArea = val.length;
                this.cityDataArr.map((value, i) => {
                    if (value.id === val[0]) {
                        value.cities.map((itec, i) => {
                            if (itec.id === val[1]) {
                                if (!itec.cities.length) {
                                    this.$get(this.$api.getArea + val[1]).then(
                                        res => {
                                            let Items = res.data;
                                            if (Items) {
                                                itec.cities = Items.map(
                                                    (every, i) => {
                                                        return {
                                                            id: every.id,
                                                            regionName:
                                                                every.regionName
                                                        };
                                                    }
                                                );
                                            }
                                        }
                                    );
                                }
                            }
                        });
                    }
                });
            }
        },
        // 点击配送网
        onDeliveryClick() {
            window.open('https://www.liancanps.com/', '_blank');
        },
    }
}
</script>

<style lang='less' scoped>
.shuxian {
    border-left: 1px solid rgba(255, 255, 255, 0.5);
    width: 0;
    height: 28px;
    margin: 0 18px;
}

.displayFlex {
    display: flex;
    align-items: center;
}

// 横幅区域
.navbar-box {
    height: 380px;
    width: 100%;
    background: #f5f5f5 url(https://liancan-oss.mmdiandi.com/FutureCanteen/top3s.png) no-repeat 50%;
    background-position: 50%;
    background-size: cover;
    padding: 0;
    min-width: 1400px;
    position: relative;
}

.navbar-box:before {
    display: table;
    content: '';
}

// 右上角功能区域
.version-box {
    text-align: right;
    width: 1400px;
    margin: 0px auto;
    padding-top: 20px;
    display: flex;
    justify-content: flex-end;

    .service-hotline {
        font-size: 16px;
        color: #fff;
        font-weight: bold;
    }

    .enter-buttons {
        display: flex;
        flex-direction: row;
        gap: 12px;

        .enter-btn {
            width: 116px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            font-size: 16px;
            color: #184BAF;
            background: #eff5ff;
            border: 1px solid #184BAF;
            border-radius: 4px;
            text-decoration: none;
            display: block;

            &:hover {
                color: #4e84e2;
                border: 1px solid #6294e9;
            }
        }
    }

    .delivery-link {
        .delivery-img {
            width: 40px;
            height: 34px;
            margin-right: 10px;
            filter: brightness(0) invert(1);
        }

        .text {
            font-size: 17px;
            color: #fff;
            font-weight: bold;
        }
    }

    .tip_off {
        .tip_img {
            width: 32px;
            height: 26px;
            margin-right: 10px;
            filter: brightness(0) invert(1);
        }

        .text {
            font-size: 17px;
            color: #fff;
            font-weight: bold;
        }
    }
}

// Logo区域
.logo-box {
    position: relative;
    top: 40px;
    height: 200px;
    width: 1400px;
    margin: 0px auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    .logo {
        display: block;
        cursor: pointer;
    }
}
</style>
<style>
.popper_class .el-select-dropdown__item {
    color: #4e84e2;
}
</style>



// WEBPACK FOOTER //
// src/components/indexModule/header.vue